import {configureStore} from "@reduxjs/toolkit";
import appSettingsReducer from "./reducers/appSettingSlice";

export default configureStore({
    reducer: {
        appSettings: appSettingsReducer
    }
});